<div class="relative" (click)="clicked.emit()">
  <div
    *ngIf="comment.isFlagged"
    class="absolute top-0 left-0 right-0 bottom-0 z-[1] backdrop-blur-[5px]"
  >
    <div class="flex flex-col items-center translate-y-1/3 h-full">
      <ark-lib-icon-name name="flagged"></ark-lib-icon-name>
      <div class="w-full bg-pink-600 mt-[18px]">
        <div
          class="text-center text-white text-[11px] font-bold uppercase leading-[18px] tracking-wide"
        >
          Reported as illegal content
        </div>
      </div>
    </div>
  </div>
  <div
    class="p-5 flex flex-col bg-white border-solid"
    [class.border-[2px]]="comment.isModerated"
    [class.border-[#e5cc6f]]="comment.isModerated"
    [class.bg-[#fff8e0]]="comment.isModerated"
  >
    <div class="flex">
      <img
        class="w-[50px] h-[50px] rounded object-cover"
        [src]="comment?.nft ?? (comment?.images | first: 'thumb')"
      />
      <div class="text-slate-900 text-lg font-semibold leading-[21px] ml-5">
        {{ comment.title }}
      </div>
    </div>
    <div class="flex justify-between items-center py-1">
      <div
        class="w-full h-[3px] bg-[#E6E1D7]"
        [class.bg-[#e5cc6f]]="comment.isModerated"
        [class.flex-[1]]="comment.isModerated"
      ></div>
      <div class="pl-[5px]">
        <div
          *ngIf="!comment.isModerated"
          class="text-stone-400 text-[11px] font-bold uppercase leading-[18px] tracking-wide w-[65px]"
        >
          Comment
        </div>
        <div
          *ngIf="comment.isModerated"
          class="text-[#e5cc6f] text-[11px] font-bold uppercase leading-[18px] tracking-wide w-[160px]"
        >
          Comment in moderation
        </div>
      </div>
    </div>

    <div class="flex items-center">
      <div class="text-slate-900 text-base font-normal leading-relaxed">
        &#64;{{ comment.creatorNickname }}
      </div>
      <div class="text-stone-400 text-sm font-normal leading-normal ml-4">
        1w
      </div>
    </div>

    <div
      class="text-[#636363] text-base font-normal leading-[21px] mt-3 line-clamp-3"
      [innerHTML]="comment.description | links"
    ></div>

    <!-- <div *ngIf="comment.isModerated" class="flex items-center justify-end my-3">
      <ark-lib-icon-name name="gavel"></ark-lib-icon-name>
      <div class="text-slate-900 text-sm font-semibold leading-normal ml-[5px]">
        Moderate (0.001 pts)
      </div>
    </div> -->

    <div
      class="flex flex-row justify-between mt-3"
    >
      <div class="flex flex-row items-center">
        <ark-lib-icon-name
          name="like"
          (click)="onUpvote($event)"
        ></ark-lib-icon-name>
        <div class="text-black text-[11px] font-normal leading-[18px] mx-[5px]">
          {{ comment.upVoteCount | numberAbbrevation }}
        </div>
        <ark-lib-icon-name
          name="dislike"
          (click)="onDownVote($event)"
        ></ark-lib-icon-name>
        <!-- <div class="text-black text-[11px] font-normal leading-[18px] mx-[5px]">
          {{ comment.downVoteCount | numberAbbrevation }}
        </div> -->
      </div>

      <div class="flex flex-row items-center" (click)="toggleReply($event)">
        <ark-lib-icon-name name="reply"></ark-lib-icon-name>
        <div class="text-black text-[11px] font-normal leading-[18px] ml-[5px]">
          Reply
        </div>
      </div>

      <div class="flex flex-row items-center" *ngIf="menuOptions.length > 0">
        <ark-lib-proposition-menu
          [options]="menuOptions"
        ></ark-lib-proposition-menu>
      </div>
    </div>
  </div>
</div>
